const hardwareSections = {
  PETIOLE: "petiole",
  MERCURY: "mercury"
};

export default hardwareSections;
